exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-active {\n  color: #d97915 !important;\n}\n.photo-overlay {\n  display: flex;\n  width: 100vw;\n  height: 100vh;\n  position: fixed;\n  background: rgba(0, 0, 0, 0.6);\n  top: 0;\n  left: 0;\n  justify-content: center;\n  align-items: center;\n}\n.photo-overlay img {\n  width: 500px;\n  height: 500px;\n  border: 4px solid white;\n  border-radius: 4px;\n}", ""]);

// exports
